export enum AuctionStatesEnum {
  Active = 'ACTIVE',
  In_The_Future = 'IN_THE_FUTURE',
  Expired = 'EXPIRED',
}
